import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface LoginState {
    currentUserDetails: any;
    signinStep: string;
    enteredWrongPassword: boolean;
    userMappedToOtherAgent: boolean;
    otpVerified: boolean;
    incorrectOtp?: any;
    portfolioDetails: any;
    userPasswordNotPresent: boolean;
    isAgentVerfied: string;
}
const rawState: LoginState = {
    currentUserDetails: null,
    signinStep: 'mobile',
    enteredWrongPassword: false,
    userMappedToOtherAgent: false,
    otpVerified: false,
    portfolioDetails: "",
    userPasswordNotPresent: false,
    isAgentVerfied: 'not_verified'
};

const intialState = fromJS(rawState);

export default function loginReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SET_SIGNIN_STEP:
            return merge(state, fromJS({ signinStep: action.payload.data }));
        case Actions.FETCH_GET_CURRENT_USER_SUCCESS:
            return merge(state, fromJS({ currentUserDetails: action.payload.data }));
        case Actions.FETCH_GET_CURRENT_USER_ERROR:
            return merge(state, fromJS({}));
        case Actions.FETCH_GET_CHECK_MOBILE_NUMBER_SUCCESS:
            if(action.payload.data?.length){
                const hasPassword =  action.payload.data?.find((element: any)=>element?.hasPassword);
                if(hasPassword){
                    return merge(state, fromJS({ 
                        userPasswordNotPresent: false,
                        signinStep: 'password'
                   }));
                }
                else{
                    return merge(state, fromJS({ 
                        userPasswordNotPresent: true,
                        signinStep: 'updatepassword'
                   }));
                }
            }
            else{
                return merge(state, fromJS({ 
                    userPasswordNotPresent: true,
                    signinStep: 'userdetails' 
                }));
            }
            
        case Actions.FETCH_VERIFY_PASSWORD_SUCCESS: {
            if (action.payload.data === null || action.payload.data === "") {
                // failed to verify password
                return merge(state, fromJS({ enteredWrongPassword: true }));
            } else {
                return merge(state, fromJS({ currentUserDetails: action.payload.data }));
            }
        }
        case Actions.FETCH_POST_VERIFY_LOGIN_OTP_SUCCESS:
            //check here
            return merge(state, fromJS({ otpVerified: true }));
        case Actions.FETCH_POST_VERIFY_LOGIN_OTP_ERROR:
            return merge(state, fromJS({ incorrectOtp: action.payload }));
        case Actions.FETCH_UPDATE_USER_PASSWORD_SUCCESS:
            return merge(state, fromJS({ currentUserDetails: action.payload.data }));
        case Actions.FETCH_USER_LOGIN_SUCCESS:
            return merge(state, fromJS({ currentUserDetails: action.payload.data?.tokenInfo }));
        case Actions.SET_ENTERED_WRONG_PASSWORD:
            return merge(state, fromJS({ enteredWrongPassword: action.payload.data }));
        case Actions.SET_USER_MAPPED_TO_OTHER_AGENT:
            return merge(state, fromJS({ userMappedToOtherAgent: action.payload.data }));
        case Actions.SET_OTP_VERIFIED:
            return merge(state, fromJS({ otpVerified: action.payload.data }));
        case Actions.SET_INCORRECT_OTP:
            return merge(state, fromJS({ incorrectOtp: action.payload.data }));
        case Actions.FETCH_GET_PORTFOLIO_DETAILS_SUCCESS:
            return merge(state, fromJS({ portfolioDetails: action.payload.data }));
        case Actions.FETCH_PARTNER_DETAILS:
            return merge(state, fromJS({ isAgentVerified: action.payload.data }));  

        default:
            return state;
    }
}

// netCurrentValue,netReturnPercentage